import { gql } from '@apollo/client';
import { ERRORS_FRAGMENT, ITINERARY_FRAGMENT } from '@/graphql/fragments';

export const FIND_ITINERARY_QUERY = gql`
    ${ERRORS_FRAGMENT}
    ${ITINERARY_FRAGMENT}
    query FindItinerary($locator: String!, $passport: String!, $recaptchaToken: String) {
        findItinerary(locator: $locator, passport: $passport, recaptchaToken: $recaptchaToken) {
            status
            errors {
                ...ErrorType
            }
            object {
                ...ItineraryType
            }
        }
    }
`;
